import React from "react";
import { PrismicToolbar } from "@prismicio/react";
import { prismicRepo } from "../../utils/constants";
import { isCrawler } from "../../utils/isCrawler";
import {
  shouldLoadPrismicToolbar,
  TOOLBAR_RECHECK_EVENT,
} from "../../utils/prismic-toolbar";
import { UserValidationContext } from "../../utils/contexts/user-validation-context";

// Loads the Prismic toolbar only for previews, opted-in editors and signed-in
// Xometry staff (MKTM-1764). Rendered client-side inside the user-validation
// provider so the staff check can read the signed-in email. Re-evaluates on
// client-side route changes (see requestToolbarRecheck), so a navigation to a
// preview path, a new ?prismic-toolbar value or a fresh preview cookie takes
// effect without a full page load.
export const PrismicToolbarGate = () => {
  const user = React.useContext(UserValidationContext);
  const signedIn = !!user.userData && user.isValid && !user.isExpired;
  const [, recheck] = React.useReducer((n: number) => n + 1, 0);

  React.useEffect(() => {
    window.addEventListener(TOOLBAR_RECHECK_EVENT, recheck);
    return () => window.removeEventListener(TOOLBAR_RECHECK_EVENT, recheck);
  }, []);

  const load = shouldLoadPrismicToolbar(
    {
      pathname: window.location.pathname,
      cookie: document.cookie,
      userEmail: signedIn
        ? user.userData?.emailAddress ?? undefined
        : undefined,
    },
    isCrawler()
  );

  return load ? <PrismicToolbar repositoryName={prismicRepo} /> : null;
};
